import React from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import Head from 'next/head';
import client, { imageBuilder } from 'sanity/client';
import PaymentCard from 'components/PaymentCard';
import serviceImg from 'public/images/service.png';

export default function ContactPage( { payments } ) {
  return (
    <>
      <Head>
        <title>Nghiện Fifa - Liên Hệ Thanh Toán</title>
      </Head>
      <section className="container mx-auto max-w-7xl px-2 sm:px-6 lg:px-8 py-4 md:py-8 lg:py-16">
        <div className="unset-img relative">
          <Image
            src={ serviceImg }
            layout="fill"
            objectFit="cover"
            className="custom-img"
            placeholder="blur"
            priority
            alt="nghien-fifa service"
            unoptimized
          />
        </div>
        <div className="mt-8 lg:mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-16 gap-y-4">
          {payments.map( ( { _id, name, accountName, accountNo, qr } ) => (
            <PaymentCard
              key={ _id }
              paymentName={ name }
              accountName={ accountName }
              accountNumber={ accountNo }
              image={ qr && imageBuilder.image( qr ).width( 300 ).quality( 50 ).url() }
            />
          ) )}
        </div>
      </section>
    </>
  );
}

ContactPage.propTypes = {
  payments: PropTypes.arrayOf( PropTypes.shape( {
    _id: PropTypes.string,
    name: PropTypes.string.isRequired,
    accountName: PropTypes.string.isRequired,
    accountNo: PropTypes.string.isRequired,
    qr: PropTypes.object,
  } ) ),
};

export async function getServerSideProps( { res } ) {
  res.setHeader(
    'Cache-Control',
    'public, maxage=31536000, immutable',
  );

  const payments = await client.fetch( '*[_type == "Payment"]' );
  return {
    props: {
      payments,
    },
  };
}
